export const taloLegal = {
  fr: {
    switchLink: {
      to: "/politique-legale/wapi",
      text: "Voir la politique légale de Wapi",
    },
    blocks: [
      { type: "h2", text: "Talo - Politique Légale" },
      {
        type: "h3",
        text: "(Confidentialité, Sécurité des données et Conditions d'utilisation)",
      },
      { type: "p", html: "<strong>Dernière mise à jour :</strong> 29 avril 2026" },
      { type: "h3", text: "1. Introduction" },
      {
        type: "p",
        html: "L'application <strong>Talo</strong> est une solution de gestion destinée aux petites et moyennes entreprises permettant la gestion des ventes, du stock, de la facturation et du suivi des activités commerciales, y compris des fonctionnalités adaptées aux pharmacies (gestion des produits et alertes d'expiration).",
      },
      {
        type: "p",
        text: "En utilisant Talo, vous acceptez la présente politique légale comprenant :",
      },
      {
        type: "ul",
        items: [
          "La politique de confidentialité",
          "Les mesures de sécurité des données",
          "Les conditions d'utilisation",
        ],
      },
      { type: "h3", text: "2. Politique de confidentialité" },
      { type: "h4", text: "2.1 Données collectées" },
      { type: "p", text: "Talo peut collecter et traiter les données suivantes :" },
      { type: "h4", text: "Données utilisateur" },
      {
        type: "ul",
        items: [
          "Nom et prénom",
          "Adresse e-mail",
          "Numéro de téléphone (si fourni)",
          "Rôle dans l'organisation (admin, caissier, gestionnaire, etc.)",
        ],
      },
      { type: "h4", text: "Données professionnelles" },
      {
        type: "ul",
        items: [
          "Produits et inventaires",
          "Ventes et transactions",
          "Historique des opérations",
          "Données de facturation",
          "Rapports financiers",
        ],
      },
      { type: "h4", text: "Données techniques" },
      {
        type: "ul",
        items: [
          "Adresse IP",
          "Type d'appareil",
          "Journaux d'utilisation (logs)",
          "Données de connexion",
        ],
      },
      { type: "h4", text: "2.2 Utilisation des données" },
      { type: "p", text: "Les données sont utilisées pour :" },
      {
        type: "ul",
        items: [
          "Fournir les fonctionnalités principales de l'application",
          "Gérer les ventes et le stock",
          "Générer des rapports financiers et statistiques",
          "Envoyer des notifications (stock faible, expiration des produits)",
          "Améliorer la performance et l'expérience utilisateur",
        ],
      },
      { type: "h4", text: "2.3 Stockage des données" },
      {
        type: "p",
        text: "Les données sont stockées de manière sécurisée sur des serveurs cloud sécurisés.",
      },
      {
        type: "ul",
        items: [
          "Les données peuvent être synchronisées en temps réel",
          "L'accès est strictement contrôlé selon les rôles utilisateurs",
        ],
      },
      { type: "h4", text: "2.4 Partage des données" },
      {
        type: "p",
        text: "Nous ne vendons pas les données des utilisateurs. Les données peuvent être partagées uniquement avec des services techniques nécessaires au fonctionnement de l'application.",
      },
      { type: "h4", text: "2.5 Conservation des données" },
      {
        type: "p",
        text: "Les données sont conservées aussi longtemps que nécessaire pour fournir les services ou respecter les obligations légales.",
      },
      { type: "h4", text: "2.6 Droits des utilisateurs" },
      { type: "p", text: "Les utilisateurs peuvent :" },
      {
        type: "ul",
        items: [
          "Accéder à leurs données",
          "Modifier certaines informations",
          "Demander la suppression de leur compte",
        ],
      },
      { type: "h4", text: "2.7 Confidentialité des enfants" },
      {
        type: "p",
        text: "Talo n'est pas destiné aux enfants de moins de 13 ans sans supervision d'un responsable légal.",
      },
      { type: "h3", text: "3. Sécurité des données" },
      { type: "h4", text: "3.1 Authentification" },
      {
        type: "ul",
        items: [
          "Connexion sécurisée des utilisateurs",
          "Gestion des sessions",
          "Contrôle des accès selon les rôles",
        ],
      },
      { type: "h4", text: "3.2 Contrôle d'accès" },
      {
        type: "ul",
        items: [
          "Système de permissions par rôle",
          "Isolation des données par entreprise",
          "Accès limité aux données autorisées uniquement",
        ],
      },
      { type: "h4", text: "3.3 Protection des données" },
      {
        type: "ul",
        items: [
          "Chiffrement des communications (HTTPS)",
          "Protection contre les accès non autorisés",
          "Règles de sécurité au niveau de la base de données",
        ],
      },
      { type: "h4", text: "3.4 Journalisation" },
      {
        type: "ul",
        items: [
          "Enregistrement des activités sensibles",
          "Suivi des connexions et actions importantes",
        ],
      },
      { type: "h4", text: "3.5 Sauvegarde" },
      {
        type: "ul",
        items: [
          "Sauvegardes régulières des données",
          "Possibilité de restauration en cas de problème technique",
        ],
      },
      { type: "h4", text: "3.6 Responsabilité de l'utilisateur" },
      { type: "p", text: "Les utilisateurs sont responsables de :" },
      {
        type: "ul",
        items: [
          "La confidentialité de leurs identifiants",
          "La sécurité de leur compte",
          "Le signalement de toute activité suspecte",
        ],
      },
      { type: "h3", text: "4. Conditions d'utilisation" },
      { type: "h4", text: "4.1 Acceptation" },
      {
        type: "p",
        text: "En utilisant Talo, vous acceptez de respecter ces conditions d'utilisation.",
      },
      { type: "h4", text: "4.2 Utilisation autorisée" },
      { type: "p", text: "Vous vous engagez à utiliser Talo uniquement pour :" },
      {
        type: "ul",
        items: [
          "La gestion légitime de votre activité professionnelle",
          "Le suivi des ventes, du stock et des opérations internes",
        ],
      },
      { type: "h4", text: "4.3 Utilisation interdite" },
      { type: "p", text: "Il est interdit de :" },
      {
        type: "ul",
        items: [
          "Utiliser l'application à des fins illégales",
          "Tenter d'accéder aux données d'autres utilisateurs",
          "Modifier ou perturber le fonctionnement de l'application",
        ],
      },
      { type: "h4", text: "4.4 Suspension de compte" },
      {
        type: "p",
        text: "Nous nous réservons le droit de suspendre ou supprimer un compte en cas de violation des présentes conditions ou d'utilisation frauduleuse ou abusive.",
      },
      { type: "h4", text: "4.5 Limitation de responsabilité" },
      {
        type: "p",
        text: 'Talo est fourni "tel quel". Nous ne garantissons pas une disponibilité continue sans interruption ou erreur.',
      },
      { type: "h4", text: "4.6 Modifications" },
      {
        type: "p",
        text: "Cette politique peut être mise à jour à tout moment. Les utilisateurs seront informés en cas de changements importants.",
      },
      { type: "h3", text: "5. Contact" },
      {
        type: "p",
        html: 'Pour toute question : Email : <a href="mailto:support@talohub.store">support@talohub.store</a>',
      },
      { type: "h3", text: "Résumé" },
      {
        type: "ul",
        items: [
          "Données utilisées uniquement pour les fonctionnalités de l'application",
          "Aucune vente de données",
          "Sécurité basée sur contrôle d'accès et chiffrement",
          "Utilisation limitée à des fins professionnelles",
        ],
      },
    ],
  },
  en: {
    switchLink: {
      to: "/politique-legale/wapi",
      text: "View Wapi legal policy",
    },
    blocks: [
      { type: "h2", text: "Talo - Legal Policy" },
      {
        type: "h3",
        text: "(Privacy, Data Security, and Terms of Use)",
      },
      { type: "p", html: "<strong>Last updated:</strong> April 29, 2026" },
      { type: "h3", text: "1. Introduction" },
      {
        type: "p",
        html: "The <strong>Talo</strong> application is a management solution for small and medium businesses, enabling sales, inventory, invoicing, and business activity tracking, including pharmacy-specific features (product management and expiry alerts).",
      },
      {
        type: "p",
        text: "By using Talo, you accept this legal policy, which includes:",
      },
      {
        type: "ul",
        items: [
          "The privacy policy",
          "Data security measures",
          "Terms of use",
        ],
      },
      { type: "h3", text: "2. Privacy Policy" },
      { type: "h4", text: "2.1 Data Collected" },
      { type: "p", text: "Talo may collect and process the following data:" },
      { type: "h4", text: "User data" },
      {
        type: "ul",
        items: [
          "First and last name",
          "Email address",
          "Phone number (if provided)",
          "Role in the organization (admin, cashier, manager, etc.)",
        ],
      },
      { type: "h4", text: "Business data" },
      {
        type: "ul",
        items: [
          "Products and inventory",
          "Sales and transactions",
          "Operation history",
          "Billing data",
          "Financial reports",
        ],
      },
      { type: "h4", text: "Technical data" },
      {
        type: "ul",
        items: [
          "IP address",
          "Device type",
          "Usage logs",
          "Connection data",
        ],
      },
      { type: "h4", text: "2.2 Use of Data" },
      { type: "p", text: "Data is used to:" },
      {
        type: "ul",
        items: [
          "Provide the application's core features",
          "Manage sales and inventory",
          "Generate financial and statistical reports",
          "Send notifications (low stock, product expiry)",
          "Improve performance and user experience",
        ],
      },
      { type: "h4", text: "2.3 Data Storage" },
      {
        type: "p",
        text: "Data is stored securely on protected cloud servers.",
      },
      {
        type: "ul",
        items: [
          "Data may be synchronized in real time",
          "Access is strictly controlled by user roles",
        ],
      },
      { type: "h4", text: "2.4 Data Sharing" },
      {
        type: "p",
        text: "We do not sell user data. Data may only be shared with technical services required for the application to function.",
      },
      { type: "h4", text: "2.5 Data Retention" },
      {
        type: "p",
        text: "Data is retained as long as necessary to provide services or meet legal obligations.",
      },
      { type: "h4", text: "2.6 User Rights" },
      { type: "p", text: "Users may:" },
      {
        type: "ul",
        items: [
          "Access their data",
          "Modify certain information",
          "Request account deletion",
        ],
      },
      { type: "h4", text: "2.7 Children's Privacy" },
      {
        type: "p",
        text: "Talo is not intended for children under 13 without supervision by a legal guardian.",
      },
      { type: "h3", text: "3. Data Security" },
      { type: "h4", text: "3.1 Authentication" },
      {
        type: "ul",
        items: [
          "Secure user login",
          "Session management",
          "Role-based access control",
        ],
      },
      { type: "h4", text: "3.2 Access Control" },
      {
        type: "ul",
        items: [
          "Role-based permission system",
          "Data isolation per business",
          "Access limited to authorized data only",
        ],
      },
      { type: "h4", text: "3.3 Data Protection" },
      {
        type: "ul",
        items: [
          "Encrypted communications (HTTPS)",
          "Protection against unauthorized access",
          "Database-level security rules",
        ],
      },
      { type: "h4", text: "3.4 Logging" },
      {
        type: "ul",
        items: [
          "Recording of sensitive activities",
          "Tracking of logins and important actions",
        ],
      },
      { type: "h4", text: "3.5 Backup" },
      {
        type: "ul",
        items: [
          "Regular data backups",
          "Restoration capability in case of technical issues",
        ],
      },
      { type: "h4", text: "3.6 User Responsibility" },
      { type: "p", text: "Users are responsible for:" },
      {
        type: "ul",
        items: [
          "Keeping their credentials confidential",
          "Securing their account",
          "Reporting any suspicious activity",
        ],
      },
      { type: "h3", text: "4. Terms of Use" },
      { type: "h4", text: "4.1 Acceptance" },
      {
        type: "p",
        text: "By using Talo, you agree to comply with these terms of use.",
      },
      { type: "h4", text: "4.2 Permitted Use" },
      { type: "p", text: "You agree to use Talo only for:" },
      {
        type: "ul",
        items: [
          "Legitimate management of your professional activity",
          "Tracking sales, inventory, and internal operations",
        ],
      },
      { type: "h4", text: "4.3 Prohibited Use" },
      { type: "p", text: "It is prohibited to:" },
      {
        type: "ul",
        items: [
          "Use the application for illegal purposes",
          "Attempt to access other users' data",
          "Modify or disrupt the application's operation",
        ],
      },
      { type: "h4", text: "4.4 Account Suspension" },
      {
        type: "p",
        text: "We reserve the right to suspend or delete an account in case of violation of these terms or fraudulent or abusive use.",
      },
      { type: "h4", text: "4.5 Limitation of Liability" },
      {
        type: "p",
        text: 'Talo is provided "as is". We do not guarantee uninterrupted or error-free availability.',
      },
      { type: "h4", text: "4.6 Changes" },
      {
        type: "p",
        text: "This policy may be updated at any time. Users will be notified of significant changes.",
      },
      { type: "h3", text: "5. Contact" },
      {
        type: "p",
        html: 'For any questions: Email: <a href="mailto:support@talohub.store">support@talohub.store</a>',
      },
      { type: "h3", text: "Summary" },
      {
        type: "ul",
        items: [
          "Data used only for application features",
          "No sale of data",
          "Security based on access control and encryption",
          "Use limited to professional purposes",
        ],
      },
    ],
  },
};
